var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import React from "react";
export class MediaObject {
    constructor(id, me) {
        this.id = id;
        this.me = me;
        this.username = "";
        this.hasvideo = false;
        this.hasaudio = true;
        this.addingpeer = true;
        this.mediacssclass = "facingcameravideo";
        this.peertag = "";
        this.videoref = React.createRef();
        this.audiored = React.createRef();
        makeObservable(this);
    }
    setMediacssclass(clss) {
        this.mediacssclass = clss;
    }
    setUserName(name) {
        this.username = name;
    }
    setAddingPeer(ms) {
        this.addingpeer = ms;
    }
    setMediaStream(ms) {
        this.mediastream = ms;
    }
    setHasVideo(has) {
        this.hasvideo = has;
    }
    setHasAudio(has) {
        this.hasaudio = has;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaObject.prototype, "username", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaObject.prototype, "hasvideo", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaObject.prototype, "hasaudio", void 0);
__decorate([
    observable,
    __metadata("design:type", MediaStream)
], MediaObject.prototype, "mediastream", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaObject.prototype, "addingpeer", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaObject.prototype, "mediacssclass", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MediaObject.prototype, "setMediacssclass", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MediaObject.prototype, "setUserName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaObject.prototype, "setAddingPeer", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MediaStream]),
    __metadata("design:returntype", void 0)
], MediaObject.prototype, "setMediaStream", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaObject.prototype, "setHasVideo", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaObject.prototype, "setHasAudio", null);
